import { Component, computed, inject, input } from '@angular/core';
import { NodePreover } from '@app/models/entity.model';
import { DatePipe } from '@angular/common';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { ConciergeComponent } from '@app/components/concierge/concierge.component';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { ViewComponent } from '@app/components/view/view.component';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { DrupalService } from '@app/services/drupal.service';
import { ViewRow } from '@app/models/view.model';

// Cusotm types for the formatted data
interface PreoverRow extends ViewRow {
  field_pr_date: string;
}

type MonthEntry = {
  month: string;
  originalDate: string;
  rows: PreoverRow[];
};

type GroupedRow = {
  year: string;
  months: MonthEntry[];
};

@Component({
  selector: 'mobi-node-preover',
  templateUrl: './node-preover.component.html',
  styleUrls: ['./node-preover.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    BreadcrumbComponent,
    ConciergeComponent,
    HeroTextComponent,
    ViewComponent,
    DatePipe,
    ContentSectionComponent,
  ],
})
export class NodePreoverComponent {
  readonly entity = input.required<NodePreover>();
  filter: { [key: string]: any } = {};
  #drupal = inject(DrupalService);

  locale = computed(() => this.#drupal.language() + '-CH');

  yearChange($event: any) {
    // Ensure new reference to trigger change detection
    const newFilter = { ...this.filter };
    if ($event.target.value) newFilter.year = $event.target.value;
    if (!$event.target.value) delete newFilter.year;

    this.filter = newFilter;
  }

  groupRowsByYearAndMonth(rows: PreoverRow[]): GroupedRow[] {
    try {
      if (!rows) return [];
      const groupedRows: GroupedRow[] = [];

      rows.forEach((row) => {
        const dateParts = row?.field_pr_date.split('-');
        const year = dateParts[0];
        const month = dateParts[1];

        let yearGroup = groupedRows.find((group) => group.year === year);

        if (!yearGroup) {
          yearGroup = { year: year, months: [] };
          groupedRows.push(yearGroup);
        }

        let monthEntry = yearGroup.months.find((m) => m.month === month);

        if (!monthEntry) {
          monthEntry = {
            month: month,
            originalDate: row.field_pr_date,
            rows: [row],
          };
          yearGroup.months.push(monthEntry);
        } else {
          monthEntry.rows.push(row);
        }
      });

      return groupedRows;
    } catch (e) {
      console.error(
        'View is not compatible with the rowFormatter function in node-preover component',
        e
      );
      return [];
    }
  }
}
